import TariffQuoteService from "@/services/quote/TariffQuoteService"
import QuoteTrackingService from "@/services/quote/QuoteTrackingService"

import Referral from "@/services/Referral.js"
import Vue from "vue"

const getInitialState = () => ({
  tariffQuotes: null,
  isFetchingQuotes: null,
  tariffFetchError: null,
  referralDetails: null,
  selectedQuote: null,
  quoteSummaryContent: null,
  isContentFetched: false,
  furthestCompletedStep: 0,
  invalidQuoteTariffName: null,
  form: {
    postcode: null,
    fuel: null,
    meterType: null,
    isMeterMultirate: null,
    supplyAddress: null,
    supplyAddressGas: null,
    estimatedUsage: null,
    exactAmountGas: { usage: null, period: "year" },
    exactAmountElec: { usage: null, period: "year" },
    seasonalPayments: null,
    bankAccountHolderName: null,
    bankAccountNumber: null,
    sortCode: null,
    paymentDay: null,
    billingAddress: null,
    isBillingAddressSameAsSupply: true,
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    dateOfBirth: null,
    priorityServiceRegister: null,
    marketingOptIn: null
  }
})

export const state = () => getInitialState()

export const mutations = {
  UPDATE_FORM(state, form) {
    state.form = { ...state.form, ...form }
  },
  RESET_FORM(state) {
    Object.assign(state, getInitialState())
  },
  SET_TARIFF_QUOTES(state, tariffQuotes) {
    state.tariffQuotes = tariffQuotes
  },
  SET_INVALID_TARIFF(state, invalidQuoteTariffName) {
    state.invalidQuoteTariffName = invalidQuoteTariffName
  },
  SET_TARIFF_FETCH_ERROR(state, error) {
    state.tariffFetchError = error
  },
  SET_TARIFF_FETCH_STATE(state, isFetching) {
    state.isFetchingQuotes = isFetching
  },
  SET_REFERRAL_DETAILS(state, referralDetails) {
    state.referralDetails = referralDetails
  },
  SET_QUOTE(state, quote) {
    state.selectedQuote = quote
  },
  SET_QUOTE_SUMMARY(state, quoteSummaryContent) {
    state.quoteSummaryContent = quoteSummaryContent
  },
  SET_CONTENT_FETCHED_FLAG(state, isContentFetched) {
    state.isContentFetched = isContentFetched
  },
  UPDATE_FURTHEST_STEP_COMPLETED(state, furthestCompletedStep) {
    state.furthestCompletedStep = furthestCompletedStep
  },
  UPDATE_MPAN(state, mpan) {
    state.form.supplyAddress.mpan = mpan
  },
  UPDATE_MPRN(state, mprn) {
    state.form.supplyAddressGas.mprn = mprn
  }
}

export const actions = {
  async fetchTariffQuotes({ state, commit }) {
    commit("SET_TARIFF_FETCH_STATE", true)
    commit("SET_TARIFF_FETCH_ERROR", null)
    try {
      const {
        quotes,
        invalidQuoteTariffName
      } = await TariffQuoteService.getQuotes(state.form)
      commit("SET_TARIFF_QUOTES", quotes)
      commit("SET_INVALID_TARIFF", invalidQuoteTariffName)
    } catch (error) {
      commit("SET_TARIFF_FETCH_ERROR", error)
      throw error
    } finally {
      commit("SET_TARIFF_FETCH_STATE", false)
    }
  },
  async ensureReferralDetailsFetched({ state, commit }) {
    // TODO: Move to a service
    const code = Vue.$cookies.get("voucher")
    const isPromoCode = Vue.$cookies.get("promotional_code_used") === "true"
    if (!code || isPromoCode || state.referralDetails) {
      return
    }
    const { data } = await Referral.checkVoucher(code)

    commit("SET_REFERRAL_DETAILS", {
      credit: data.current_referral_fee,
      referrer: data.referrer,
      code
    })
  },
  async fetchLayoutContent({ state, commit }) {
    if (state.isContentFetched) return

    const [{ story: quoteSummary }] = await Promise.all([
      this.$storyblokHelper.get({
        id: "website/quote/summary"
      })
    ])

    commit("SET_QUOTE_SUMMARY", quoteSummary.content)
    commit("SET_CONTENT_FETCHED_FLAG", true)
  },
  setPostcodeAndReset({ commit }, postcode) {
    commit("RESET_FORM")
    commit("UPDATE_FORM", { postcode: postcode.toUpperCase() })
    QuoteTrackingService.unregisterTrackedInputs()
  }
}

export const getters = {}
